import ActionTypes from '../actionsTypes'

export interface CalcProjectStore {
  projectNumber?: string
}

interface Action {
  type: string
  payload: any
}

const initialState: CalcProjectStore = {
  projectNumber: undefined,
}

export default (state: CalcProjectStore = initialState, action: Action): CalcProjectStore => {
  switch (action.type) {
    case ActionTypes.SET_CALC_PROJECT:
      return Object.assign({}, state, {
        ...action.payload.data,
      })
    default:
      return state
  }
}
